/**
 * Legacy `/app/league-detail` URL — redirects to the Fixtures stack route so bookmarks
 * still work. Primary navigation uses `/app/gameResults/league-detail`.
 */

import { useMemo } from 'react'
import { Redirect, useLocalSearchParams } from 'expo-router'

export default function LegacyLeagueDetailRedirect() {
  const { league, leagueId, countryCode } = useLocalSearchParams<{
    league?: string
    leagueId?: string
    countryCode?: string
  }>()
  const href = useMemo(() => {
    const params = new URLSearchParams()
    if (league != null && league !== '') params.set('league', String(league))
    if (leagueId != null && leagueId !== '') params.set('leagueId', String(leagueId))
    if (countryCode != null && countryCode !== '') params.set('countryCode', String(countryCode))
    const qs = params.toString()
    return qs ? `/app/gameResults/league-detail?${qs}` : '/app/gameResults/league-detail'
  }, [league, leagueId, countryCode])

  return <Redirect href={href} />
}
